/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationSpecialtyAliases {
  CHECKBOX_0 = 'checkbox-0',
  DYNAMIC_FIELD_MAIN_SPECIALTY = 'dynamic-field-mainSpecialty',
  FETCH_FIELD_OF_WORK = 'fetch-field-of-work',
  FETCH_LIST_SPECIALTY = 'fetch-list-specialty',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_SPECIALTIES = 'fetch-specialties',
  FIELD_0 = 'field-0',
  FIELD_CARD = 'field-card',
  FIELD_FIELD_OF_WORK = 'field-field-of-work',
  FIELD_FIELD_OF_WORK_LIST = 'field-field-of-work-list',
  FIELD_MAIN_SPECIALTY = 'field-main-specialty',
  FIELD_NR_SEQUENCE = 'field-nrSequence',
  FIELD_NR_SEQUENCE_LIST = 'field-nrSequence-list',
  FIELD_SPECIALTY = 'field-specialty',
  FIELD_SPECIALTY_LIST = 'field-specialty-list',
  FORM_0 = 'form-0',
  FORM_PANEL = 'form-panel',
  FORM_SPECIALTY = 'form-specialty',
  INPUT_NR_SEQUENCE = 'input-nrSequence',
  INPUT_NR_SEQUENCE_LIST = 'input-nrSequence-list',
  LAYOUT_GENERAL_INFORMATION = 'layout-general-information',
  LIST_PANEL = 'list-panel',
  MAPPER_0 = 'mapper-0',
  MAPPER_4 = 'mapper-4',
  MAPPER_10 = 'mapper-10',
  MY_DATA_CARD = 'my-data-card',
  MY_DATA_DECK = 'my-data-deck',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_PROVIDER_ACCREDITATION_SPECIALTY = 'panel-provider-accreditation-specialty',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
  TEXT_3_LIST = 'text-3-list',
  TEXT_4 = 'text-4',
  TEXT_4_LIST = 'text-4-list',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_FIELD_OF_WORK = 'unboxed-field-of-work',
  UNBOXED_SPECIALTY = 'unboxed-specialty',
}
export { ProviderAccreditationSpecialtyAliases };
